function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 0A1.5 1.5 0 000 1.5v17A1.5 1.5 0 001.5 20h13a1.5 1.5 0 001.5-1.5V7.036a2.5 2.5 0 00-.732-1.768L10.732.732A2.5 2.5 0 008.964 0H1.5zm1.75 8a.75.75 0 01-.75-.75v-.5A.75.75 0 013.25 6h7a.75.75 0 01.75.75v.5a.75.75 0 01-.75.75h-7zm9.5 4.5a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75h-9.5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75h9.5zm0 4.5a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75h-9.5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75h9.5z",
  fill: "url(#doc_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "doc_svg__paint0_linear",
  x1: 3,
  y1: 0,
  x2: 15.711,
  y2: 2.326,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgDoc = function SvgDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgDoc;